export const TRANSACTION_ATTEMPT_LOG_LIST_REQUEST = 'TRANSACTION_ATTEMPT_LOG_LIST_REQUEST';
